import { SessionService } from 'app/core/auth/session.service';
import { map, distinctUntilChanged } from 'rxjs';
import { forEach } from 'lodash';

import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DOM_EMP_TODAS, DomEmpSelector } from 'app/design-amz/selectors/dom-emp/dom-emp.selector';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent
} from '@fuse/components/navigation';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Usr } from 'app/common/models/usr.model';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';



import { QuickChatComponent } from 'app/layout/common/quick-chat/quick-chat.component';



import { UsrService } from 'app/modules/adm/usr/usr.service';
import { EmpService } from 'app/common/services/emp.service';
import { EmpLogoService } from 'app/common/services/emp-logo.service';
import { Subject, takeUntil, Subscription, forkJoin, skip } from 'rxjs';
import { PresenceService } from 'app/common/services/presence.service';
import { NavbarService } from 'app/common/services/navbar.service';
import { DocService } from 'app/common/services/doc.service';
import { UtilsService } from 'app/common/services/utils.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { CommonModule, CurrencyPipe, NgClass, NgTemplateOutlet, TitleCasePipe } from '@angular/common';
import { DatePipe } from '@angular/common';
import { defaultNavigation } from 'app/mock-api/common/navigation/data';
import { ModuleTitlePipe } from 'app/common/pipes/module-title.pipe';
import { ParService } from 'app/common/services/par.service';
import { Utils } from 'app/common/utils';
import { UsrFotoService } from 'app/common/services/usr-foto.service';
import { FevService } from 'app/common/services/fev.service';
import { RcvService } from 'app/common/services/rcv.service';


@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [
    FuseLoadingBarComponent,
    FuseVerticalNavigationComponent,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    NgClass,
    RouterOutlet,
    QuickChatComponent,
    DatePipe,
    CurrencyPipe,
    ModuleTitlePipe
],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' }]
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
    formatRut = ''
    uf = 12345.67;
    fevVencidos = 0;
    private _loadingVencidos = false;
    comprasPendientes = 0;
    moduleName = 'cox';
    winWidth = window.innerWidth;

    @HostListener('window:resize')
    onResize(): void { this.winWidth = window.innerWidth; }
    ahora: Date = new Date();
    isClientesRoute = false;
    isLoggedIn: boolean = false;
    isMoroso: boolean = false;

    usr_name = '';
    usr_img = 'assets/images/users/foto.png';

    /** Logo de la empresa de la sesión (null = no tiene → se muestra nombre + RUT en texto). */
    empLogoSrc: string | null = null;
    /** Object URL del logo recortado a su contenido (null = mostrar empLogoSrc tal cual). */
    empLogoVista: string | null = null;
    private _empLogoAnalizado: string | null = null;

    /** Tooltip de la foto: nombre y correo del usuario (ya no se muestran como texto). */
    get usrTooltip(): string {
        return this.usr ? `${this.usr_name}\n${this.usr.emai}` : '';
    }

    /** El botón Dominio del menú lateral es exclusivo del usuario tipo DOM
     *  (ve todas las empresas de su dominio; mismos accesos que CEO). */
    get esDom(): boolean {
        return String(this.usr?.tipo ?? '').trim().toUpperCase() === 'DOM';
    }

    /** Vistas del holding / dominio (ger/dbg-hol, ger/dbg-dom, adm/acc-hol): no hay
     *  "empresa" activa que mostrar — se oculta el logo/nombre de la empresa en el menú. */
    get enVistaDominio(): boolean {
        const url = this._router.url;
        return url.startsWith('/ger/dbg-hol') || url.startsWith('/ger/dbg-dom') || url.startsWith('/adm/acc-hol');
    }

    /** Tooltip del número de dominio (pie del menú, en dbg-dom). */
    get domTooltip(): string {
        const name = this.usr?.dom?.name;
        if (!name) return 'Holding';
        return `Holding: ${name === 'AMAZING INNOVATION SOFTWARE SPA' ? 'AMAZING IA' : name}`;
    }

    private _dialog = inject(MatDialog);
    private _toastr = inject(ToastrService);
    private _cambiandoEmpresa = false;

    /** Botón Dominio: monoselector "Todas las Empresas" + empresas del dominio.
     *  Elegir otra empresa la deja como activa de la sesión (backend SES.KEMP):
     *  el contexto nuevo refresca menú/logo/kemp y se recarga ger/dbg. */
    onDomClick(): void {
        if (this._cambiandoEmpresa) return;
        this.session.empresasDominio().pipe(takeUntil(this._unsubscribeAll)).subscribe({
            next: ({ actual, empresas }) => {
                const marcada = this.enVistaDominio ? DOM_EMP_TODAS : actual;
                this._dialog.open(DomEmpSelector, { data: { empresas, actual: marcada } }).afterClosed()
                    .subscribe((kemp: number | undefined) => {
                        if (kemp == null || kemp === marcada) return;
                        if (kemp === DOM_EMP_TODAS) {
                            // Modo dominio: Dashboard Holding (todas las empresas del dominio).
                            this._router.navigateByUrl('/ger/dbg-hol');
                            return;
                        }
                        if (kemp === actual) {
                            // Desde "Todas" de vuelta a la empresa activa: solo su tablero.
                            this._router.navigateByUrl('/ger/dbg');
                            return;
                        }
                        this._cambiarEmpresa(kemp);
                    });
            },
            error: () => this._toastr.error('No se pudieron cargar las empresas del dominio'),
        });
    }

    private _cambiarEmpresa(kemp: number): void {
        this._cambiandoEmpresa = true;
        this.session.cambiarEmpresa(kemp).subscribe({
            next: () => {
                this._cambiandoEmpresa = false;
                // Pasar por '/' fuerza a recrear ger/dbg aunque ya estuviera abierto
                // (sus datos se cargan en ngOnInit con el kemp de la sesión).
                this._router.navigateByUrl('/', { skipLocationChange: true })
                    .then(() => this._router.navigateByUrl('/ger/dbg'));
            },
            error: () => {
                this._cambiandoEmpresa = false;
                this._toastr.error('No se pudo cambiar de empresa');
            },
        });
    }

    /** Tooltip del logo: datos de la empresa que el logo reemplaza en pantalla. */
    get empTooltip(): string {
        const e = this.usr?.emp;
        if (!e) return '';
        return `${e.name}\n${this.formatRut}`;
    }

    /** Otros usuarios de la empresa con la app abierta — se muestran bajo la
     *  foto del usuario actual. Se refresca con cada latido (30 s). */
    enLinea: { kusr: number; name: string; img: string; ipad: string | null; navegador: string; desde: Date | null; inicioLocal: number; empresa: string | null }[] = [];
    presenceError = false;
    presenceErrorMessage = '';

    isScreenSmall: boolean;
    navigationOpened: boolean = true;
    navigation: Navigation;
    user: User;
    usr: Usr;
    usrxrole: Usr;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private _pendingCompactNavId: number | null = null;
    /**
     * Id del grupo top-level (`navigation.default`) actualmente mostrado
     * expandido en el menú. Fuse solo auto-colapsa un grupo cuando NINGUNO
     * de sus hijos es la ruta activa (ver `_hasActiveChild` en
     * collapsable.component.ts) — al "hojear" otro módulo desde la columna
     * compacta SIN navegar (ver onCompactIconClick), el módulo activo sigue
     * conteniendo la ruta activa y por eso esa protección de Fuse NO lo
     * colapsaría solo. Este campo es lo que nos permite colapsarlo a mano
     * igual, y sincronizarlo de vuelta cuando el usuario navega de verdad
     * (ver el handler de NavigationEnd en ngOnInit).
     */
    private _expandedModuleId: string | null = null;

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _usrService: UsrService,
        private _empService: EmpService,
        private _empLogo: EmpLogoService,
        private session: SessionService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _navBarService: NavbarService,
        private _utilsService: UtilsService,
        private _parService: ParService,
        private utils: Utils,
        private _usrFoto: UsrFotoService,
        private _fevService: FevService,
        private _docService: DocService,
        private _rcvService: RcvService,
        private _presenceService: PresenceService,
    ) {}

    subscription: Subscription = new Subscription();

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Oculta la barra superior (UF, hora, notificaciones) en páginas
        // pensadas para verse fuera del staff, como /clientes (link con token).
        this.isClientesRoute = this._router.url.startsWith('/clientes');
        this._router.events
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.isClientesRoute = event.urlAfterRedirects.startsWith('/clientes');

                    // DOM: el menú depende de si está en la vista holding o dentro de
                    // una empresa — recalcular solo cuando cambia de una a otra.
                    if (this.esDom && this.enVistaDominio !== this._menuVistaDominio) {
                        this._menuVistaDominio = this.enVistaDominio;
                        this._filterNavigationForUser(this.usr);
                    }

                    // Mantiene _expandedModuleId sincronizado con la navegación
                    // "de verdad" (leaf clickeada con el menú abierto, URL
                    // tipeada a mano, etc.) — Fuse ya expande/colapsa los grupos
                    // correspondientes solo en este caso (ver
                    // collapsable.component.ts, suscripción a NavigationEnd);
                    // acá solo reflejamos cuál quedó activo para que
                    // onCompactIconClick sepa cuál colapsar si más tarde el
                    // usuario "hojea" otro módulo sin navegar.
                    const activeTop = this.navigation?.default?.find((i) =>
                        this.isActiveGroup(i)
                    );
                    if (activeTop) {
                        this._expandedModuleId = activeTop.id;
                    }

                    // Contrae el menú lateral en cada navegación. Decenas de
                    // componentes de página (ban/ctb, sii/iva, vta/*, etc.)
                    // tienen en su propio ngOnInit un `navigation.toggle()`
                    // heredado (ver window.innerWidth >= 960) que compite con
                    // este cierre — el orden exacto entre "se activa el
                    // componente destino" y "dispara NavigationEnd" no es
                    // confiable, así que esta acción (open u close, según
                    // corresponda) se difiere a un macrotask (setTimeout 0)
                    // para que corra DESPUÉS de cualquier toggle() sincrónico
                    // de esos ngOnInit y así siempre tenga la última palabra.
                    //
                    // _pendingCompactNavId: onCompactIconClick() navega a un
                    // módulo distinto al activo y quiere terminar con el menú
                    // ABIERTO en vez de cerrado. Un simple flag booleano
                    // "_suppressAutoClose" (versión anterior) se rompía si
                    // esta navegación disparaba más de un NavigationEnd antes
                    // de que el flag se consumiera (p.ej. algún guard/efecto
                    // secundario dispara una segunda navegación imperativa) —
                    // el primer NavigationEnd consumía el flag correctamente,
                    // pero el segundo ya lo encontraba en false y programaba
                    // un close() que pisaba la reapertura. Comparar contra el
                    // id de navegación exacto que onCompactIconClick() dejó
                    // pendiente es inmune a eso: solo ESE NavigationEnd abre,
                    // cualquier otro (de esta navegación o de cualquier otra)
                    // sigue el camino normal de cierre.
                    if (
                        this._pendingCompactNavId !== null &&
                        event.id === this._pendingCompactNavId
                    ) {
                        this._pendingCompactNavId = null;
                        setTimeout(() => {
                            const mainNav =
                                this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                                    'mainNavigation'
                                );
                            mainNav?.open();
                        });
                    } else {
                        setTimeout(() => {
                            const mainNav =
                                this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                                    'mainNavigation'
                                );
                            mainNav?.close();
                        });
                    }

                    // Menú admin restringido: solo la cuenta admin@amzprp.cl puede
                    // navegar dentro de "Dashboard" (adm/dsh), "Empresas" (adm/emp),
                    // "Usuarios" (adm/usr) y "Control de Acceso" (adm/acc) — si
                    // escribe/guardó otra URL (ej. ger/dbg), la devuelve al Dashboard.
                    // Se excluyen las rutas de aut/* para no bloquear login/logout.
                    // OJO: kemp=1 (la empresa "AMAZING PRP") por sí solo NO alcanza —
                    // hay ~7 cuentas de prueba/demo también asociadas a esa empresa
                    // que deben ver el menú extendido normal, no este restringido.
                    if (
                        this.utils.isSuperAdmin(this.usr) &&
                        !event.urlAfterRedirects.startsWith('/adm/dsh') &&
                        !event.urlAfterRedirects.startsWith('/adm/emp') &&
                        !event.urlAfterRedirects.startsWith('/adm/usr') &&
                        !event.urlAfterRedirects.startsWith('/adm/acc') &&
                        !event.urlAfterRedirects.startsWith('/aut/')
                    ) {
                        this._router.navigateByUrl('adm/dsh');
                    }
                }
            });

        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(navigation => {
                this.navigation = navigation;
                this._filterNavigationForUser(this.usr);
            });
        this._navigationService.isMoroso$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(isMoroso => this.isMoroso = isMoroso);

        this._iniciarPresencia();

        // Al subir una foto (adm/acc) se recargan la propia y las de usuarios en línea.
        this._usrFoto.version$.pipe(skip(1), takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (this.usr?.id) this.usr_img = this._usrFoto.url(this.usr.id);
            this.enLinea = this.enLinea.map(u => ({ ...u, img: this._usrFoto.url(u.kusr) }));
        });

        // Logo cambiado en adm/acc → recargar el del menú sin caché.
        this._empLogo.version$.pipe(skip(1), takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (this.usr?.kemp) this._setEmpLogoSrc(this._empLogo.url(this.usr.kemp));
        });

        this.subscription = this.session.state$.pipe(
            map(state => state.status === 'authenticated' ? state.context : null),
            distinctUntilChanged(),
            takeUntil(this._unsubscribeAll),
        ).subscribe(context => {
            this.isLoggedIn = !!context;
            this.usr = context ? this._usrService.usuarioDeContexto(context) : null;
            this.usrxrole = this.usr;
            if (!context) {
                this.usr_name = '';
                this.formatRut = '';
                this.usr_img = 'assets/images/users/foto.png';
                this._setEmpLogoSrc(null);
                this.fevVencidos = 0;
                this.comprasPendientes = 0;
                return;
            }
            this._filterNavigationForUser(this.usr);
            this.formatRut = this.utils.frmRut(context.company.rutt);
            this.usr_name = context.user.name.split(' ').map(part => this.capStr(part)).join(' ');
            // Dominio bajo el rut = el de la EMPRESA de la sesión (EMP.KDOM), no
            // USR.KDOM (puede quedar en '*' si el usuario se creó sin dominio).
            // context.company no trae kdom, así que se resuelve con una consulta aparte.
            if (context.company?.id) {
                this._empService.domDeEmpresa(context.company.id)
                    .pipe(takeUntil(this._unsubscribeAll))
                    .subscribe(dom => { if (this.usr) this.usr = { ...this.usr, dom }; });
            }
            // Foto propia: BD → assets/<id>.png → genérica (onUsrImgError).
            this.usr_img = this._usrFoto.url(context.user.id);
            // Logo de la empresa: EMP.LOGO → assets/images/logos/<kemp>.* → null (texto).
            this._setEmpLogoSrc(this._empLogo.url(context.company.id));
            const now = this.ahora;
            this._parService.getUf(now.getFullYear(), now.getMonth() + 1, now.getDate())
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(res => this.uf = Number(res));
            this._loadFevVencidos();
            this._loadComprasPendientes();
            // El resolver pudo cargar el menu antes del login: refrescar con la empresa actual.
            this._navigationService.get().pipe(takeUntil(this._unsubscribeAll)).subscribe();
        });

        // Subscribe to the user service
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });

        this._navBarService.modulo.subscribe((res) => {
            console.log('navBar.modulo', res);
            // Se difiere al siguiente microtask: el módulo de la ruta hija
            // suele llamar setModulo() en su propio ngOnInit, en el mismo ciclo
            // en que este layout ya validó su vista (ExpressionChangedAfterItHasBeenCheckedError).
            Promise.resolve().then(() => {
                this.moduleName = res;
            });
        });

        this._utilsService.dateObs.subscribe((currentDate) => {
            //console.log('ahora', currentDate)
            this.ahora = currentDate;
        });

        // Recalcula el contador cuando un evento cambia en cualquier pantalla
        // (ej. al mover la fecha de un evento vencido en fin/fev).
        this._fevService.changed$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => this._loadFevVencidos());

        // Recalcula "Facturas pendientes de Acuse de Recibo" cuando sii/rcv
        // reimporta el RCV o se envían facturas a Acuse de Recibo.
        this._rcvService.changed$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => this._loadComprasPendientes());
    }

    // Botón naranjo del header — total (todos los períodos) de RCV con
    // OPER='PEN' para el kemp actual. Espejo de _loadFevVencidos(), sin
    // evento de recarga propio (a diferencia de fev, nada en pantalla emite
    // hoy un "changed$" al confirmar/descartar una compra pendiente).
    private _loadComprasPendientes(): void {
        const state = this.session.snapshot;
        const kemp = state.status === 'authenticated' ? state.context?.company.id : null;
        if (!kemp) return;

        this._rcvService.countPendientes(kemp).subscribe(cant => {
            this.comprasPendientes = cant;
        });
    }

    private _loadFevVencidos(): void {
        const state = this.session.snapshot;
        const kemp = state.status === 'authenticated' ? state.context?.company.id : null;
        if (!kemp) return;

        // Guard obligatorio: cada delete() de la limpieza de abajo emite su propio
        // changed$ (uno por FEV eliminado), y este método está suscrito a changed$
        // más abajo en ngOnInit — sin el guard, forkJoin de N deletes dispara N
        // reejecuciones concurrentes de este método (cada una relanzando su propia
        // consulta de 9999 filas + su propia limpieza), formando un loop de
        // peticiones en cascada. Visto en producción tras subir take de 200→9999:
        // requests idénticos a /api/fev/list cada ~500ms sin parar.
        if (this._loadingVencidos) return;
        this._loadingVencidos = true;

        const hoy = new Date();
        const ayer = new Date(hoy.getTime() - 86_400_000);
        // fec1=ayer replica exactamente el filtro (stat=PROY, hasta=ayer) que usa
        // irAFevProy() al navegar — antes se pedía una página de 200 sin filtro de
        // fecha y se filtraba en el cliente, subcontando "vencidos" reales frente
        // al total que el listado mostraba después de hacer click en la alerta.
        this._fevService.list(kemp, 1, 9999, undefined, ayer, 'PROY')
            .subscribe({
                next: (res) => {
                    const vencidos = res.data;
                    const conDoc = vencidos.filter(f => f.KDOC && (f.TDOC === 'FAP' || f.TDOC === 'FEP'));
                    if (conDoc.length === 0) {
                        this.fevVencidos = vencidos.length;
                        this._loadingVencidos = false;
                        return;
                    }
                    // Una sola petición batch (WHERE KDOC IN (...) en el backend) en vez
                    // de un GET por documento — antes esto disparaba hasta ~200 requests
                    // individuales en cada carga de página, en cualquier pantalla de la app.
                    this._docService
                        .getPagosByDocsBatch(conDoc.map(f => f.KDOC), kemp)
                        .subscribe({
                            next: (pagosPorDoc) => {
                                const aEliminar = conDoc.filter(f =>
                                    (pagosPorDoc[f.KDOC] || []).some((p: any) => p.TIPO === 'AJUSTE INICIAL')
                                );
                                if (aEliminar.length === 0) {
                                    this.fevVencidos = vencidos.length;
                                    this._loadingVencidos = false;
                                    return;
                                }
                                forkJoin(aEliminar.map(f => this._fevService.delete(f.ID)))
                                    .subscribe({
                                        next: () => {
                                            const eliminadosIds = new Set<number>(aEliminar.map(f => f.ID));
                                            this.fevVencidos = vencidos.filter(f => !eliminadosIds.has(f.ID)).length;
                                            this._loadingVencidos = false;
                                        },
                                        error: () => { this._loadingVencidos = false; },
                                    });
                            },
                            error: () => { this._loadingVencidos = false; },
                        });
                },
                error: () => { this._loadingVencidos = false; },
            });
    }

    /**
     * On destroy
     */
    private _iniciarPresencia(): void {
        this._presenceService.state$.pipe(
            takeUntil(this._unsubscribeAll),
        ).subscribe(({ users: lista, error, errorMessage }) => {
            this.presenceError = error;
            this.presenceErrorMessage = errorMessage;
            // Se conserva la imagen resuelta de quien seguía en línea,
            // actualizando su nombre. Si su
            // foto había fallado (caía a la genérica), NO se conserva: se
            // reintenta en este ciclo (p.ej. el servidor estaba caído).
            const previos = new Map(this.enLinea.filter(u => u.img !== UsrFotoService.GENERICA).map(u => [u.kusr, u]));
            const otros = new Map(lista.filter(u => Number(u.kusr) !== Number(this.usr?.id))
                .map(u => [Number(u.kusr), u]));
            this.enLinea = Array.from(otros.values()).map(u => ({
                kusr: u.kusr,
                name: u.name.split(' ').map(part => this.capStr(part)).join(' '),
                img: previos.get(u.kusr)?.img ?? this._usrFoto.url(u.kusr),
                ipad: u.ipad,
                navegador: this.utils.navegadorDeUA(u.uagt),
                empresa: u.empresa ? `${u.empresa} #${u.kemp}` : null,
                desde: u.desde ? new Date(u.desde) : null,
                // Inicio expresado en el reloj LOCAL (a partir de los segundos que
                // midió Oracle): el contador no se corre si el PC tiene otra hora.
                inicioLocal: Date.now() - (Number(u.segs) || 0) * 1000,
            }));
        });
    }

    /** Tooltip de la foto de otro usuario en línea (se recalcula con cada tic de `ahora`). */
    tooltipEnLinea(u: ClassyLayoutComponent['enLinea'][number]): string {
        const seg = Math.max(0, Math.floor((this.ahora.getTime() - u.inicioLocal) / 1000));
        const min = Math.floor(seg / 60);
        const desde = u.desde
            ? u.desde.toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
            : '—';
        return [
            u.name,
            // Solo en la vista global del superadmin (usuarios de todas las empresas).
            ...(u.empresa ? [`Empresa: ${u.empresa}`] : []),
            `IP: ${u.ipad ?? '—'}`,
            `Navegador: ${u.navegador}`,
            `Conectado desde: ${desde}`,
            `Tiempo conectado: ${min} min ${String(seg % 60).padStart(2, '0')} s`,
        ].join('\n');
    }


    /** Foto de otro usuario: BD → assets/<id>.png → genérica. */
    onEnLineaImgError(u: { kusr: number; img: string }): void {
        const next = this._usrFoto.fallback(u.img, u.kusr);
        if (next) u.img = next;
    }

    /** Foto propia: BD → assets/<id>.png → genérica. */
    onUsrImgError(): void {
        const id = this.usr?.id;
        if (!id) return;
        const next = this._usrFoto.fallback(this.usr_img, id);
        if (next) this.usr_img = next;
    }

    /** Siguiente fuente del logo (BD → assets con cada extensión); null = mostrar texto. */
    onEmpLogoError(): void {
        if (this.empLogoVista) { this._setEmpLogoVista(null); return; } // vista recortada falló → la original
        if (!this.empLogoSrc || !this.usr?.kemp) return;
        this.empLogoSrc = this._empLogo.fallback(this.empLogoSrc, this.usr.kemp);
    }

    /**
     * Al cargar el logo (fuente real, no la vista recortada): se muestra
     * RECORTADO a su contenido (sin márgenes transparentes) y, si es oscuro,
     * sobre una placa clara ajustada (si no, se pierde en el menú).
     */
    onEmpLogoLoad(): void {
        const src = this.empLogoSrc;
        if (!src || this.empLogoVista || src === this._empLogoAnalizado) return;
        this._empLogoAnalizado = src;
        this._empLogo.analizar(src).pipe(takeUntil(this._unsubscribeAll)).subscribe(r => {
            if (this.empLogoSrc !== src) { if (r.url) URL.revokeObjectURL(r.url); return; }
            this._setEmpLogoVista(r.url);
        });
    }

    /** Cambia la fuente del logo: descarta la vista recortada/placa de la anterior. */
    private _setEmpLogoSrc(src: string | null): void {
        this._setEmpLogoVista(null);
        this._empLogoAnalizado = null;
        this.empLogoSrc = src;
    }

    private _setEmpLogoVista(url: string | null): void {
        if (this.empLogoVista) URL.revokeObjectURL(this.empLogoVista);
        this.empLogoVista = url;
    }

    trackEnLinea(_: number, u: { kusr: number }): number {
        return u.kusr;
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Filtra this.navigation.default según el usuario logueado. Se llama en
     * cada emisión de navigation$ (no solo al montar el layout) porque
     * initialDataResolver vuelve a pedir la navegación completa en cada
     * navegación de ruta.
     */

    /** Vista (holding o empresa) con la que se armó el menú del DOM la última vez. */
    private _menuVistaDominio: boolean | null = null;

    private _filterNavigationForUser(usr: Usr): void {
        if (!usr || !this.navigation) return;
        this._menuVistaDominio = this.enVistaDominio;
        this.navigation.default = [];
        // USR.TIPO se compara normalizado (sin espacios, en mayúsculas): un
        // 'Ram' o 'RAM ' en la base dejaba el menú VACÍO al no calzar con '==='.
        const tipo = String(usr.tipo ?? '').trim().toUpperCase();

        if (this.utils.isSuperAdmin(usr)) {
            // Menú admin restringido (solo admin@amzprp.cl, empresa 1):
            // "Dashboard" (primera opción y aterrizaje del login) + "Empresas"
            // (mantenedor CRUD de EMP) + "Usuarios" + "Administración > Control
            // de Acceso" + Salir. Sin Finanzas (2026-09-27: antes traía
            // Configuración > Conceptos de Flujo).
            const admGroup = defaultNavigation.find((item) => item.id === 'adm');
            const dshItem = admGroup?.children?.find((child) => child.id === 'adm.dsh');
            const empItem = admGroup?.children?.find((child) => child.id === 'adm.emp');
            const usrItem = admGroup?.children?.find((child) => child.id === 'adm.usr');
            const accItem = admGroup?.children?.find((child) => child.id === 'adm.acc');
            const logoutItem = defaultNavigation.find((item) => item.id === 'aut.login');

            if (dshItem) this.navigation.default.push(dshItem);
            if (empItem) this.navigation.default.push(empItem);
            if (usrItem) this.navigation.default.push(usrItem);
            if (admGroup && accItem) {
                // admGroup trae `hidden: () => true` (en data.ts está oculto porque
                // normalmente solo se aplanan sus hijos sueltos, ver empItem/usrItem
                // arriba) — hay que pisarlo o el grupo clonado queda invisible pese a
                // estar en this.navigation.default.
                this.navigation.default.push({ ...admGroup, hidden: undefined, children: [accItem] });
            }
            if (logoutItem) this.navigation.default.push(logoutItem);
        } else if (tipo === 'DOM' && this.enVistaDominio) {
            // DOM en la vista holding ("Todas las Empresas": ger/dbg-hol, adm/acc-hol):
            // menú solo de Gerencia + Administración. "Gerencia" abre el Tablero de
            // Control Holding (ger/dbg-hol), no el de una empresa (ger/dbg). Con una
            // empresa puntual elegida (botón Dominio) ve el menú completo, como un
            // CEO — rama siguiente (2026-10-07, pedido del usuario).
            const gerItem = defaultNavigation.find((item) => item.id === 'ger.dbg');
            if (gerItem) {
                this.navigation.default.push({ ...this._cloneNavItem(gerItem), subtitle: 'Tablero de Control Holding', link: '/ger/dbg-hol' });
            }
            // "Control de Acceso" del DOM → adm/acc-hol (versión holding; por ahora clon de adm/acc).
            const admGroup = defaultNavigation.find((item) => item.id === 'adm');
            const accItem = admGroup?.children?.find((child) => child.id === 'adm.acc');
            if (admGroup && accItem) {
                this.navigation.default.push({ ...admGroup, hidden: undefined, children: [{ ...accItem, link: '/adm/acc-hol' }] });
            }
            const logoutItem = defaultNavigation.find((item) => item.id === 'aut.login');
            if (logoutItem) this.navigation.default.push(logoutItem);
        } else if (tipo === 'FINAL' || tipo === 'RAM' || tipo === 'CEO' || tipo === 'DOM') {
            // FINAL, RAM y CEO (2026-09-26): mismo menú de negocio. RAM y CEO
            // ven además "Administración > Control de Acceso" (ver más abajo);
            // FINAL no (2026-09-27: se sumó RAM, antes era exclusiva del CEO).
            // Menú por id (antes era por índice fijo — frágil ante inserciones en
            // defaultNavigation, p.ej. el módulo 'hon' Honorarios). FINAL ve todo
            // menos Dominios/Usuarios/Empresas de 'adm' (son administración de
            // sistema); mantiene el mismo orden que defaultNavigation. 'hon' va
            // entre Compra y Caja. "Administración > Control de Acceso" se arma
            // aparte, igual que en la rama superadmin, para no exponer el resto
            // de 'adm' (que sí sigue vedado a FINAL).
            const finalIds = [
                'ger.dbg', 'ofv', 'crm', 'vta', 'cmp', 'hon',
                'cfwa', 'ban', 'fin', 'sii', 'nwk', 'mor', 'cfg',
            ];
            for (const id of finalIds) {
                const item = defaultNavigation.find((i) => i.id === id);
                // Clonado profundo (no structuredClone: hay `hidden: () => true`
                // en algunos grupos, y las funciones no son clonables) — defensivo:
                // antes una poda con splice() mutaba el `defaultNavigation` compartido
                // (singleton de módulo) y borraba fin.edr/fin.cta para SIEMPRE. La poda
                // por empresa actual (Utils.filterNavigationByCompany) ya no muta.
                if (item) this.navigation.default.push(this._cloneNavItem(item));
            }
            // FINAL con Control de Acceso configurado (USR.ACCS no vacío): solo lo
            // concedido — antes FINAL veía todo e ignoraba lo marcado en adm/acc.
            // Misma regla que landingUrlFor (Utils.accsVigentes).
            const granted = this.utils.accsVigentes(usr);
            if (granted) {
                this.navigation.default = this.utils.filterNavigationByGrantedIds(this.navigation.default, granted);
            }
            if (tipo === 'RAM' || tipo === 'CEO' || tipo === 'DOM') {
                const admGroup = defaultNavigation.find((item) => item.id === 'adm');
                const accItem = admGroup?.children?.find((child) => child.id === 'adm.acc');
                if (admGroup && accItem) {
                    this.navigation.default.push({ ...admGroup, hidden: undefined, children: [accItem] });
                }
            }
            const logoutItem = defaultNavigation.find((item) => item.id === 'aut.login');
            if (logoutItem) this.navigation.default.push(logoutItem);
        } else if (tipo === 'COMUN') {
            // Usuario común: solo ve los módulos/opciones que su Control de Acceso
            // (USR.ACCS, editado en adm/acc — ver AccComponent) le concedió. El
            // árbol de adm/acc ya excluye 'adm'/'aut.login'/'company' de lo
            // seleccionable, así que un filtro recursivo simple alcanza — ningún
            // id de esas ramas puede aparecer en accs. 'Salir' se agrega siempre,
            // como en las otras dos ramas, para no dejar al usuario sin forma de
            // cerrar sesión.
            let granted: Set<string>;
            try {
                granted = new Set<string>(JSON.parse(usr.accs || '[]'));
            } catch {
                granted = new Set<string>();
            }
            // La poda vive en Utils.filterNavigationByGrantedIds — también la usa
            // Utils.landingUrlFor() (login.component.ts) para saber dónde aterriza
            // este usuario; deben quedar siempre en sincro.
            this.navigation.default = this.utils.filterNavigationByGrantedIds(defaultNavigation, granted);
            const logoutItem = defaultNavigation.find((item) => item.id === 'aut.login');
            if (logoutItem) this.navigation.default.push(logoutItem);
        } else {
            // Tipo no contemplado: al menos "Salir", y dejar rastro para
            // diagnosticar (antes quedaba el menú vacío sin ninguna pista).
            console.warn(`[menu] USR.TIPO no contemplado: "${usr.tipo}" (usr ${usr.id})`);
            const logoutItem = defaultNavigation.find((item) => item.id === 'aut.login');
            if (logoutItem) this.navigation.default.push(logoutItem);
        }

        // Ítems exclusivos de una empresa (edr/cta → 208, nwk → 164, ofv → 6),
        // para cualquier tipo de usuario. La tabla vive en
        // Utils.NAV_EXCLUSIVO_EMPRESA — la comparte el árbol de adm/acc.
        this.navigation.default = this.utils.filterNavigationByCompany(this.navigation.default, usr.kemp);

        // "Configuración > Puesta en marcha" (cfg.pms): solo para usuarios tipo RAM
        // (pedido del usuario 2026-10-09). Poda sin mutar (los ítems pueden venir
        // de defaultNavigation, que es un singleton compartido).
        if (tipo !== 'RAM') {
            const sinPms = (items: FuseNavigationItem[]): FuseNavigationItem[] => items
                .filter((i) => i.id !== 'cfg.pms')
                .map((i) => (i.children ? { ...i, children: sinPms(i.children) } : i));
            this.navigation.default = sinPms(this.navigation.default);
        }
    }

    /** Clon profundo de un ítem de navegación preservando funciones (ej. `hidden`),
     *  que structuredClone no soporta. Crea un array `children` nuevo en cada nivel
     *  para que splice()/push() posteriores nunca muten `defaultNavigation`. */
    private _cloneNavItem(item: FuseNavigationItem): FuseNavigationItem {
        return item.children
            ? { ...item, children: item.children.map((child) => this._cloneNavItem(child)) }
            : { ...item };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        console.log('--> toggleNavigation name', name);
        // Get the navigation
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );
        console.log('navigation', navigation);
        if (navigation) {
            // El nombre del módulo YA NO se limpia acá al colapsar/expandir —
            // pedido explícito del usuario (2026-08-22): al colapsar el menú
            // debe verse "Amazing PRP / <módulo>" en el mismo estilo Bauhaus
            // (ver classy.component.html), así que moduleName tiene que
            // seguir disponible en ambos estados de navigationOpened. La
            // plantilla decide qué estilo mostrar, no este método.
            // Si estaba cerrado, va a abrirse: partir siempre desde arriba
            // (logo/perfil de usuario), no desde el scroll que haya quedado
            // de una apertura anterior vía onCompactIconClick (que sí baja
            // el scroll a propósito para mostrar el grupo clickeado).
            const wasClosed = !navigation.opened;
            // Toggle the opened status
            navigation.toggle();
            if (wasClosed) {
                navigation.scrollToTop();
            }
        }
    }

    /**
     * Indica si `item` (o alguno de sus hijos) corresponde a la ruta activa —
     * usado para destacar en azure el ícono del módulo actual en la columna
     * compacta cuando el menú lateral está contraído.
     */
    isActiveGroup(item: FuseNavigationItem): boolean {
        if (item.link && this._router.url.startsWith(item.link)) {
            return true;
        }
        return item.children?.some((child) => this.isActiveGroup(child)) ?? false;
    }

    /**
     * Click en un ícono de la columna compacta.
     *
     * - Ítem sin hijos (Gerencia, Salir: un link suelto sin submenú): no hay
     *   nada que expandir, el único destino posible es su propio link — este
     *   es el único caso que navega, reemplazando el componente activo.
     * - Ítem con hijos (Venta, Configuración, etc.), sea el módulo activo o
     *   uno distinto: NUNCA navega. Solo abre el panel y deja expandida
     *   ÚNICAMENTE la rama de `item` — el componente mostrado en el
     *   contenido no cambia.
     *   - Si `item` es el módulo activo, esa rama ya está expandida en la
     *     hoja correspondiente (el árbol de `fuse-vertical-navigation` no se
     *     destruye al compactar/expandir — ver vertical.component.html, sin
     *     `*ngIf`/`@if` sobre `opened`), así que expandirla de nuevo es un
     *     no-op y el usuario cae exactamente donde estaba.
     *   - Si `item` es un módulo distinto, Fuse protege del auto-colapso a
     *     la rama que contiene la ruta activa (`_hasActiveChild` en
     *     collapsable.component.ts) — como acá NO navegamos, esa protección
     *     nunca se desactiva sola. Por eso colapsamos a mano la rama que
     *     `_expandedModuleId` recuerda como la mostrada hasta ahora, para
     *     que quede una sola rama abierta a la vez (la recién clickeada).
     *   Ambas ramas usan `.expand()`/`.collapse()` llamados directamente
     *   sobre la instancia de FuseVerticalNavigationCollapsableItemComponent
     *   correspondiente — se auto-registra en FuseNavigationService bajo su
     *   propio `item.id` (ver collapsable.component.ts) porque Fuse no
     *   expone una API pública para "expandir/colapsar grupo X por id"
     *   desde afuera del árbol.
     */
    onCompactIconClick(item: FuseNavigationItem): void {
        const reopen = () => {
            const navigation =
                this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                    'mainNavigation'
                );
            navigation?.open();
        };

        if (!item.children?.length) {
            if (this.isActiveGroup(item)) {
                reopen();
                return;
            }
            const link = item.link ?? this._firstLink(item);
            if (link) {
                this._router.navigateByUrl(link);
                this._pendingCompactNavId = this._router.getCurrentNavigation()?.id ?? null;
            } else {
                reopen();
            }
            return;
        }

        reopen();
        if (this._expandedModuleId && this._expandedModuleId !== item.id) {
            this._fuseNavigationService
                .getComponent<{ collapse: () => void }>(this._expandedModuleId)
                ?.collapse();
        }
        const group = this._fuseNavigationService.getComponent<{
            expand: () => void;
            scrollIntoView: () => void;
        }>(item.id);
        group?.expand();
        this._expandedModuleId = item.id;
        // Diferido: que el panel ya esté abierto/expandido (transición CSS +
        // change detection) antes de desplazar el scroll, para que el ítem
        // quede arriba del viewport visible con sus hijos hacia abajo.
        setTimeout(() => group?.scrollIntoView());
    }

    private _firstLink(item: FuseNavigationItem): string | null {
        if (item.link) {
            return item.link;
        }
        for (const child of item.children ?? []) {
            const link = this._firstLink(child);
            if (link) {
                return link;
            }
        }
        return null;
    }

    /**
     * Click en cualquier ítem hoja del menú lateral (los `<a>` con routerLink
     * que renderiza `basic.component.html`, distintos de los `<div>` que usan
     * los grupos colapsables — ver collapsable.component.html). Cierra el menú
     * de inmediato.
     *
     * Necesario además del cierre en NavigationEnd (ver ngOnInit): si el link
     * apunta a la ruta ya activa, Angular Router no navega (comportamiento por
     * defecto `onSameUrlNavigation: 'ignore'`, sin configurar en
     * app.config.ts), por lo que NavigationEnd nunca se dispara y ese cierre
     * nunca corre — sin este handler el menú quedaba abierto en ese caso.
     */
    onNavItemClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        if (target.closest('a.fuse-vertical-navigation-item')) {
            const mainNav =
                this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                    'mainNavigation'
                );
            mainNav?.close();
        }
    }

    /**
     * Se dispara cuando el panel lateral se abre/cierra (manualmente o por resize).
     * El logo+texto "Amazing PRP" del panel superior solo se muestra cuando el
     * panel lateral NO está visible, para no repetirlo.
     */
    onNavigationOpenedChanged(opened: boolean): void {
        // Se difiere al siguiente microtask por el mismo motivo que navBar.modulo:
        // el evento se emite durante el ngOnChanges del hijo, en el mismo ciclo
        // en que este layout ya validó su vista (ExpressionChangedAfterItHasBeenCheckedError).
        Promise.resolve().then(() => {
            this.navigationOpened = opened;
        });
    }

    irAFevProy(): void {
        const hoy = new Date();
        const ayer = new Date(hoy.getTime() - 86_400_000);
        const ayerStr = `${ayer.getFullYear()}-${String(ayer.getMonth()+1).padStart(2,'0')}-${String(ayer.getDate()).padStart(2,'0')}`;
        this._router.navigate(['/fin/fev'], { queryParams: { stat: 'PROY', hasta: ayerStr } });
    }

    irAComprasPendientes(): void {
        this._router.navigate(['/sii/rcv'], { queryParams: { tab: 'pen' } });
    }

    capStr(str: string): string {
        if (str) {
            str = str.toLowerCase();
            return str.charAt(0).toUpperCase() + str.slice(1);
        } else {
            return '';
        }
    }


}
